module.exports = __webpack_public_path__ + "img/Group 97847.16e00acd.png";